import Axios from "../utils/http-request";
import { getRequestConfiguration } from "../utils/headerHelper";
import { AxiosErrorResponse } from "../interface/api_request";

// Get all notifications
export const apifetchNotifications = async () => {
  const cfg = getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  const { data } = await Axios.get(`/admin/supports/notifications`, cfg);
  return data;
};

// Get notification by ID
export const apifetchNotificationById = async (id: string) => {
  const cfg = getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  try {
    const uri = `/notifications/${id}`;
    return await Axios.get(uri, cfg);
  } catch (e: any) {
    const error = e as AxiosErrorResponse;
    const errorMessage =
      error?.response?.data?.message ||
      error?.response?.data?.msg ||
      error?.message ||
      "An error occurred";
    return {
      data: {},
      status: "error",
      msg: errorMessage,
    };
  }
};

// Update notification by ID
export const updateNotification = async (id: string) => {
  const cfg = getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  const response = await Axios.put(
    `/notifications/notification/${id}`,
    {},
    cfg,
  );
  return response.data;
};

export const deleteNotification = async (id: string) => {
  const cfg = getRequestConfiguration({
    "Content-Type": "application/x-www-form-urlencoded",
  });
  const response = await Axios.delete(`/notifications/notification/${id}`, cfg);
  return response.data;
};
